<script lang="ts" setup>
defineOptions({ inheritAttrs: false });
defineProps<{
  value: string;
  name: string;
  dataTestId?: string;
}>();
const checked = defineModel<boolean>('checked', {
  default: false,
});
defineSlots<{
  default: () => VNode[];
}>();

const attrs = useAttrs();

const bordered = computed(() => !!(attrs.checked || checked.value));
</script>

<template>
  <label
    class="baseRadioPlate"
    :class="{ baseRadioPlate_bordered: bordered }"
    :data-test-id="dataTestId"
  >
    <BaseRadio
      v-model:checked="checked"
      :value="value"
      :name="name"
      dark
      size="s"
      v-bind="attrs"
    />
    <slot />
  </label>
</template>

<style lang="scss">
.baseRadioPlate {
  height: 43px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.2px;
  color: #121212;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &_bordered {
    border-color: #121212;
  }
}
</style>
